/**
 * API base URL for backend (Django).
 * When run locally: React dev server → http://127.0.0.1:8000/api
 * Override with REACT_APP_API_URL in .env for production or custom endpoints.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';
